/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { isBoundedDependencies } from './dependenciesIsBounded.generated.js';
import { createConstantNode } from '../../factoriesNumber.js';
export var ConstantNodeDependencies = {
  NodeDependencies,
  isBoundedDependencies,
  createConstantNode
};